export default __webpack_public_path__ + "static/media/Strawberry Juice - proportioned_170.a1a8fa2b.jpg";